import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-customer-profile-notification-setting',
  templateUrl: './customer-profile-notification-setting.component.html',
})
export class CustomerProfileNotificationSettingComponent
  implements OnInit, OnDestroy
{
  notificationMenu = true;
  customerNotificationForm!: FormGroup;
  notification = [
    {
      heading: 'Customer Authentication Emailer',
      placholder: '',
      formControlName: 'CustomerAuthenticationEmailer',
    },
    {
      heading: 'Customer Transaction Emailer',
      placholder: '',
      formControlName: 'CustomerTransactionEmailer',
    },
    {
      heading: 'Customer Refund Emailer ',
      placholder: '',
      formControlName: 'CustomerRefundEmailer',
    },
    {
      heading: 'Merchant Transaction Emailer ',
      placholder: '',
      formControlName: 'MerchantTransactionEmailer',
    },
    {
      heading: 'Merchant Refund Emailer ',
      placholder: '',
      formControlName: 'MerchantRefundEmailer',
    },
  ];
  customerDataObsSubscription!: Subscription;
  customerDataEventObsSubscription!: Subscription;
  roles: any;
  userRole: any;

  constructor(
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
    private readonly userService: UserService,


  ) {}

  ngOnInit(): void {
    this.initForm();
    this.userRole = this.userService.getUserRole();
    this.customerDataObsSubscription = this.customerService
      .getCustomerDataObservable()
      .subscribe((res) => {
        console.log(res);
        this.roles=res?.role?.type
        this.patchCustomerNotificationData(res);
      });
    this.customerDataEventObsSubscription = this.customerService
      .getCustomerFormDataEventObsevable()
      .subscribe((res) => {
        console.log(res);
        this.customerService.sendCustomerFormData(
          this.customerNotificationForm.value
        );
      });
  }

  initForm() {
    this.customerNotificationForm = this.formBuilder.group({
      smsNotify: [''],
      emailNotify: [''],
      // CustomerTransactionEmailer: [''],
      // CustomerRefundEmailer: [''],
      // MerchantTransactionEmailer: [''],
      // MerchantRefundEmailer: [''],
      // TransactionFailedAlert: [''],
      // MerchantTransactionEmailID: [''],
      // MerchantTransactionSMS: [''],
    });
  }

  patchCustomerNotificationData(data: any) {
    this.customerNotificationForm.patchValue({
      smsNotify: data?.notifyConfig?.smsNotify,
      emailNotify: data?.notifyConfig?.emailNotify,
      // CustomerTransactionEmailer: data.CustomerTransactionEmailer,
      // CustomerRefundEmailer: data.CustomerRefundEmailer,
      // MerchantTransactionEmailer: data.MerchantTransactionEmailer,
      // MerchantRefundEmailer: data.MerchantRefundEmailer,
      // TransactionFailedAlert: data.TransactionFailedAlert,
      // MerchantTransactionEmailID: data.MerchantTransactionEmailID,
      // MerchantTransactionSMS: data.MerchantTransactionSMS,
    });
  }

  ngOnDestroy(): void {
    this.customerDataObsSubscription?.unsubscribe();
    this.customerDataEventObsSubscription?.unsubscribe();
  }
}
